import { Text, useStyleConfigV2 } from '@tectonic/elemason-components';
import { Clickable } from '@tectonic/uikit';
import {
  useElemasonAnalyticsContext,
  useElemasonPageContext,
} from '../../contexts';
import { useHaloScript } from '../../hooks/useHaloScript';

import type {
  ElemasonFilterListWidget,
  ElemasonWidgetAction,
  HaloScript,
} from '@tectonic/types';
import type { FC } from 'react';

interface ElemasonFilterListWidgetProps {
  widget: ElemasonFilterListWidget;
}

const sortAndGroup = (items: any[]) => {
  const sorted = items.sort((a, b) => a.title.localeCompare(b.title));

  const result: Record<string, any[]> = {};
  sorted.forEach((item) => {
    const { title } = item;
    // Determine the grouping key
    const key = title[0]?.toLowerCase().match(/[a-zA-Z]/)
      ? title[0]?.toLowerCase()
      : '#';

    // Create a new group if it doesn't exist
    if (!result[key]) {
      result[key] = [];
    }

    // Add the item to the corresponding group
    result[key].push(item);
  });

  return result;
};

// TODO: fix types
const FilterListWidgetItem = ({
  item,
  style,
  className,
  onClick,
  config,
  wAction,
}: any) => {
  const action = useHaloScript(wAction as HaloScript<ElemasonWidgetAction>);
  return (
    <Clickable
      key={item.title}
      style={style}
      className={className}
      onClick={() => onClick(action)}
    >
      <Text data={item.title} config={config?.entryText} />
    </Clickable>
  );
};

const FilterListWidget: FC<ElemasonFilterListWidgetProps> = ({
  widget: { config, data },
}) => {
  const { dispatch } = useElemasonPageContext();
  const analyticsContext = useElemasonAnalyticsContext();
  const sortedAndGroupedData = sortAndGroup(data?.items ?? []);
  const [style, className] = useStyleConfigV2(config?.container ?? {});
  const [entryStyle, entryClassName] = useStyleConfigV2(config?.entry ?? {});
  const [sectionStyle, sectionClassName] = useStyleConfigV2(
    config?.section ?? {}
  );
  const [sectionTitleStyle, sectionTitleClassName] = useStyleConfigV2(
    config?.sectionTitle ?? {}
  );
  const [subSectionStyle, subSectionClassName] = useStyleConfigV2(
    config?.subSection ?? {}
  );

  const onClick = (action: ElemasonWidgetAction) => {
    if (action) {
      dispatch(action, analyticsContext);
    }
  };

  return (
    <div style={style} className={className}>
      {Object.entries(sortedAndGroupedData).map(([key, items]) => (
        <div key={key} style={sectionStyle} className={sectionClassName}>
          <div style={sectionTitleStyle} className={sectionTitleClassName}>
            <Text data={key} config={config?.sectionText} />
          </div>

          <div style={subSectionStyle} className={subSectionClassName}>
            {items.map((item) => (
              <FilterListWidgetItem
                item={item}
                key={item.title}
                style={entryStyle}
                className={entryClassName}
                onClick={onClick}
                config={config}
                wAction={item.action}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export { FilterListWidget };
